
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { namespace } from 'vuex-class';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_list: `${FCAPI}/boss/hundun/datacenter/user`,
  teacher_get_list: `${FCAPI}/boss/hundun/setting/teacher`
};
// interface Form {
//   charge: string;
//   branch_id: string;
//   charge_teacher_id: string;
//   statistics_time: [];
// }
function initForm() {
  return {
    charge: '',
    branch_id: '',
    charge_teacher_id: '',
    statistics_time: []
  };
}

@Component
export default class MissionDetail extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项

  // 搜索框负责人列表
  get teacher_with_none() {
    let s = [...this.teacher_list];
    return s.slice(1);
  }

  search_overview_form = initForm(); // 概况搜索表单重置
  search_detail_form = initForm(); // 明细搜索表单重置
  locale = zhCN;
  is_loading = false; // 加载效果
  table_overview_data: any = []; // 概况表格数据
  table_detail_data: any = []; // 明细表格数据
  table_overview_list: any = {}; // 学员概况报表
  table_detail_list: any = {}; // 学员明细报表
  teacher_table_data: any = []; // 负责班主任列表
  is_export: any = 1; // 是否导出
  defaultSheet: any = 0;
  overview_page: number = 0;
  detail_page: number = 0;

  //created钩子函数
  created() {
    this.getOverviewList();
    this.getDetailList();
    this.getTeacherList();
    this.search_detail_form.branch_id = this.branch_office[0].value;
    this.search_detail_form.charge_teacher_id = '全部';
  }

  // 获取概况表格数据
  async getOverviewList(page = 1) {
    this.is_loading = true;
    const send_data = {
      current: page,
      limit: 20,
      is_detail: 0
    };
    // const { data: res } = await this.$axios.get(API.get_list);
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status !== 200) {
      return this.$message.error('获取学员统计报表数据失败');
    }
    this.table_overview_list = res.data.data;
    this.table_overview_data = res.data.data.detail;
    this.is_loading = false;
    this.overview_page = this.table_overview_list.current;
  }

  // 获取明细表格数据
  async getDetailList(page = 1) {
    this.is_loading = true;
    const send_data = {
      current: page,
      limit: 20,
      is_detail: 1
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status !== 200) {
      return this.$message.error('获取学员统计报表数据失败');
    }
    this.table_detail_list = res.data.data;
    this.table_detail_data = res.data.data.detail;
    this.is_loading = false;
    this.detail_page = this.table_detail_data.current;
  }
  // 分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  // 获取负责班主任列表
  async getTeacherList() {
    const teacher_send_data = {
      weixin_nickname: '',
      charge: '',
      current: 1,
      page: 999999999
    };
    const teacher_url = getUrl(API.teacher_get_list, teacher_send_data);
    const res: any = await this.$axios.get(teacher_url);
    if (res.status !== 200) {
      // this.teacher_table_data = res.data.data.detail ? res.data.data.detail : [];
      this.$message.error('获取负责班主任列表失败');
    }
    this.teacher_table_data = res.data.data.detail ? res.data.data.detail : [];
  }
  // 切换概况分页
  async changeOverviewPage(page: any) {
    if (page.current != this.overview_page) {
      this.overview_page = page.current;
      this.overviewSearch(page.current);
    }
  }
  //切换明细分页
  async changeDetailPage(page: any) {
    if (page.current != this.overview_page) {
      this.detail_page = page.current;
      this.detailSearch(page.current);
    }
  }
  // 清空概况搜索框内容
  clearForm() {
    this.search_overview_form = initForm();
  }
  // 清空明细搜索框内容
  clearForm2() {
    this.search_detail_form = initForm();
  }
  // 概况搜索
  async overviewSearch(page = 1) {
    this.is_loading = true;
    const start_time = this.search_overview_form.statistics_time[0] ? Math.floor((this.search_overview_form.statistics_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.search_overview_form.statistics_time[1]
      ? Math.floor((this.search_overview_form.statistics_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1
      : '';
    const send_data = {
      charge: this.search_overview_form.charge ? this.search_overview_form.charge : '',
      time_start: start_time,
      time_end: end_time,
      current: page,
      limit: 20
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error('获取失败');
      this.is_loading = false;
    }
    this.table_overview_list = res.data.data;
    this.table_overview_data = res.data.data.detail ? res.data.data.detail : [];
    this.is_loading = false;
  }
  // 明细搜索
  async detailSearch(page = 1) {
    this.is_loading = true;
    const start_time = this.search_detail_form.statistics_time[0] ? Math.floor((this.search_detail_form.statistics_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.search_detail_form.statistics_time[1] ? Math.floor((this.search_detail_form.statistics_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const send_data = {
      branch_id: this.search_detail_form.branch_id === '0' ? '' : this.search_detail_form.branch_id,
      charge: this.search_detail_form.charge ? this.search_detail_form.charge : '',
      charge_teacher_id: this.search_detail_form.charge_teacher_id === '0' ? '' : this.search_detail_form.charge_teacher_id,
      time_start: start_time,
      time_end: end_time,
      current: page,
      limit: 20,
      is_detail: 1
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error('获取失败');
      this.is_loading = false;
    }
    this.table_detail_list = res.data.data;
    this.table_detail_data = res.data.data.detail ? res.data.data.detail : [];
    this.is_loading = false;
  }
  // 概况数据导出
  async overviewExportData() {
    const start_time = this.search_overview_form.statistics_time[0] ? Math.floor((this.search_overview_form.statistics_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.search_overview_form.statistics_time[1]
      ? Math.floor((this.search_overview_form.statistics_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1
      : '';
    const send_data = {
      charge: this.search_overview_form.charge,
      time_start: start_time,
      time_end: end_time,
      is_export: this.is_export
    };
    const url = getUrl(API.get_list, send_data);
    this.$axios.get(url).then((res) => {
      if (res.data.status === 504) {
        this.$message.error('没有权限操作');
      } else {
        this.$message.success('导出成功');
        window.location.href = url;
      }
    });
  }
  // 明细数据导出
  async detailExport() {
    const start_time = this.search_overview_form.statistics_time[0] ? Math.floor((this.search_overview_form.statistics_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.search_overview_form.statistics_time[1]
      ? Math.floor((this.search_overview_form.statistics_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1
      : '';
    const send_data = {
      branch_id: this.search_detail_form.branch_id === '0' ? '' : this.search_detail_form.branch_id,
      charge: this.search_detail_form.charge,
      charge_teacher_id: this.search_detail_form.charge_teacher_id === '0' ? '' : this.search_detail_form.charge_teacher_id,
      time_start: start_time,
      time_end: end_time,
      is_export: this.is_export,
      is_detail: 1
    };
    const url = getUrl(API.get_list, send_data);
    this.$axios.get(url).then((res) => {
      if (res.data.status === 504) {
        this.$message.error('没有权限操作');
      } else {
        this.$message.success('导出成功');
        window.location.href = url;
      }
    });
  }
  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  // 表格排序
  onFilter(value: any, record: any) {
    record.name.indexOf(value) === 0;
  }
  sorter(a: any, b: any) {
    a.name.length - b.name.length;
  }
}
